<mat-form-field class="syn--full-width" appearance="outline">
    <mat-label>{{ placeholder }}</mat-label>
    <mat-select [required]="required" [(ngModel)]="options" #formControl="ngModel" class="syn--full-width" [placeholder]="placeholder">
        <mat-option *ngFor="let status of data" [value]="status" [disabled]="disabledOptions?.includes(status)">
            {{disabledOptions?.includes(status) ? status + " " + disabledMessage : status}}
        </mat-option>
    </mat-select>
</mat-form-field>
